import React from "react";

import { LayoutGrid, List } from "lucide-react";

export type VideoLayout = "cards" | "list";

const OPTIONS = [
  { id: "cards", label: "Card view", Icon: LayoutGrid },
  { id: "list", label: "List view", Icon: List },
] as const;

interface LayoutToggleProps {
  value: VideoLayout;
  onChange: (layout: VideoLayout) => void;
  disabled?: boolean;
}

const LayoutToggle: React.FC<LayoutToggleProps> = ({
  value,
  onChange,
  disabled = false,
}) => (
  <div
    className="library-layout-toggle"
    role="tablist"
    aria-label="Video layout"
  >
    {OPTIONS.map(({ id, label, Icon }) => (
      <button
        key={id}
        type="button"
        role="tab"
        className={`library-layout-toggle__btn${
          value === id ? " is-active" : ""
        }`}
        aria-label={label}
        aria-selected={value === id}
        title={label}
        disabled={disabled}
        onClick={() => onChange(id)}
      >
        <Icon size={14} aria-hidden />
      </button>
    ))}
  </div>
);

export default LayoutToggle;
